import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";

const CAT_STYLE = {
  COMMERCIAL: "bg-emerald-50 text-emerald-700",
  OPERATIONS: "bg-sky-50 text-sky-700",
  COMMUNICATION: "bg-violet-50 text-violet-700",
  DOCUMENTS: "bg-amber-50 text-amber-700",
  SYSTEM: "bg-slate-100 text-slate-600",
  SUPPORT: "bg-rose-50 text-rose-700",
};

export const RecordTimeline = ({ etype, eid, refreshKey = 0 }) => {
  const [data, setData] = useState(null);
  const [filter, setFilter] = useState("ALL");
  useEffect(() => {
    api.get(`/collab/timeline/${etype}/${eid}`)
      .then(({ data }) => setData(data)).catch(() => setData({ items: [] }));
  }, [etype, eid, refreshKey]);

  if (!data) return <div className="flex items-center gap-2 text-xs text-slate-400 py-3"><Loader2 className="h-3.5 w-3.5 animate-spin" /> Loading timeline…</div>;
  const items = data.items.filter((e) => filter === "ALL" || e.category === filter);

  return (
    <div data-testid="record-timeline">
      <div className="flex gap-1 flex-wrap mb-2">
        {(data.categories || ["ALL"]).map((c) => (
          <button key={c} onClick={() => setFilter(c)}
            data-testid={`timeline-filter-${c.toLowerCase()}`}
            className={`text-[10px] uppercase tracking-wide rounded-full px-2 py-0.5 border ${filter === c
              ? "border-slate-900 bg-slate-900 text-white"
              : "border-slate-200 text-slate-500 hover:bg-slate-50"}`}>
            {c}
          </button>
        ))}
      </div>
      {items.length === 0
        ? <div className="text-xs text-slate-400 py-2">No events{filter !== "ALL" ? " in this category" : ""}.</div>
        : (
          <div className="relative pl-4 space-y-2.5 before:absolute before:left-[5px] before:top-1 before:bottom-1 before:w-px before:bg-slate-200">
            {items.map((e, i) => (
              <div key={i} className="relative" data-testid={`timeline-event-${i}`}>
                <span className="absolute -left-[13.5px] top-1 h-2 w-2 rounded-full bg-slate-300 ring-2 ring-white" />
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-xs font-medium text-slate-800">{e.title}</span>
                  <span className={`text-[9px] uppercase tracking-wide rounded px-1 py-0.5 ${CAT_STYLE[e.category] || CAT_STYLE.SYSTEM}`}>{e.category}</span>
                  <span className="text-[10px] text-slate-400 ml-auto">{(e.at || "").slice(0, 16).replace("T", " ")}</span>
                </div>
                {e.detail && <div className="text-[11px] text-slate-500 mt-0.5 break-words">{e.detail}</div>}
                {e.by && <div className="text-[10px] text-slate-400">{e.by}</div>}
              </div>
            ))}
          </div>
        )}
    </div>
  );
};

export default RecordTimeline;
